var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"white"}},[_c('v-card-text',[_c('v-progress-circular',{staticClass:"mb-0 mr-3",attrs:{"indeterminate":"","color":"primary","width":4}}),_vm._v("\n    Loading, please wait\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }